exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form {\n  width: 70%;\n  margin-left: 15%;\n  margin-top: 2em;\n}\nform .help {\n  padding-left: 1.7em;\n  margin-top: -1em;\n}\n.spacer {\n  margin: 1em 0;\n  display: inline-block;\n}\n /deep/ cxScrollable {\n  width: calc(100% + 12px);\n  margin: 0 -6px;\n}\n /deep/ cxScrollable > div {\n  overflow-x: hidden;\n}\n /deep/ cxScrollable > div > table {\n  width: 100%;\n  margin: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/sysman/src/app/sysman-time-config/sysman-time-config.component.less
// module id = 1478
// module chunks = 2